import React from 'react'
import { string } from 'prop-types'
import './index.scss'

const SignUpBottom = ({ name, type, moduleId }) => (
  <a href="/baby-club/join-now">
    <div
      className="sign-up-bottom"
      data-module={name}
      data-module-name={name}
      data-module-id={moduleId}
      data-module-type={type}
    />
  </a>
)

SignUpBottom.propTypes = {
  name: string,
  moduleId: string,
  type: string,
}

SignUpBottom.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default SignUpBottom



// WEBPACK FOOTER //
// ./components/baby-club/sign-up-bottom/index.js